import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {ignoreDomainSwitchHttpStatus, SwitchDomainService} from 'ngx-auth-util-lib';
import {DomainType, HekaEmptyPageContainerComponent, NgxHekaDesignLibModule} from 'ngx-heka-design-lib';
import {Subscription} from 'rxjs';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {MultiDomainMgmtService} from 'src/app/services/multi-domain-mgmt.service';
import {environment} from 'src/environments/local/environment';
import {ComponentsModule} from '../components.module';

@Component({
  selector: 'app-sanctioned-company',
  imports: [ComponentsModule, TranslateModule, MatButtonModule, NgxHekaDesignLibModule, HekaEmptyPageContainerComponent],
  templateUrl: './sanctioned-company.component.html',
  standalone: true,
  styleUrl: './sanctioned-company.component.scss'
})
export class SanctionedCompanyComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  lastActiveDomainId?: string;

  constructor(
    private loadingService: LoadingService,
    private multiDomainMgmtService: MultiDomainMgmtService,
    private switchDomainService: SwitchDomainService
  ) {
  }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile(true).subscribe({
        next: profile => {
          this.loadingService.setLoading(false);
          if (profile) {
            const foundDomain = profile.domains?.find(d => d.domainType == DomainType.JOINED);

            if (foundDomain) {
              this.lastActiveDomainId = foundDomain.domainId;
            }
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  switchLastActiveDomain() {
    this.loadingService.setLoading(true);
    if (this.lastActiveDomainId) {
      this.switchDomainService.switchDomain(this.lastActiveDomainId).subscribe({
        error: err => {
          this.loadingService.setLoading(false);
          if (err?.status != ignoreDomainSwitchHttpStatus) {
            throw err;
          }
          this.routeToHcp();
        },
        complete: () => {
          this.loadingService.setLoading(false);
          this.routeToHcp();
        }
      });
    }
  }

  private routeToHcp() {
    window.location.href = environment.links.applications.hcp;
  }
}
